export default "__VITE_ASSET__Cfmk4NF$__"